import TariffPage from './components/TariffPage';

const routes = [
  {
    path: '/tariff/:page?',
    name: 'menu.tariff',
    icon: 'calendar-check',
    customIcon: false,
    loginRequired: true,
    component: TariffPage,
    weight: 199,
    permission: ['frontend_menu_tariffs'],
    children: [],
  },
];

export default routes;
